import type {
  ChallengeDTO,
  EventDTO,
  LeaderboardEntry,
  LeagueDTO,
  PredictionDTO,
  PublicProfileDTO
} from '../types/domain'

const nextSaturday = new Date()
nextSaturday.setUTCDate(nextSaturday.getUTCDate() + ((6 - nextSaturday.getUTCDay() + 7) % 7 || 7))
nextSaturday.setUTCHours(22, 0, 0, 0)

const fighters = {
  gamrot: {
    id: 'f-gamrot', slug: 'mateusz-gamrot', name: 'Mateusz Gamrot', nickname: 'Gamer', countryCode: 'PL',
    countryName: 'Polônia', weightClass: 'Peso-leve', rank: 6
  },
  salkilld: {
    id: 'f-salkilld', slug: 'tom-nolan', name: 'Quillan Salkilld', nickname: null, countryCode: 'AU',
    countryName: 'Austrália', weightClass: 'Peso-leve', rank: 11
  },
  sandhagen: {
    id: 'f-sandhagen', slug: 'cory-sandhagen', name: 'Cory Sandhagen', nickname: 'The Sandman', countryCode: 'US',
    countryName: 'Estados Unidos', weightClass: 'Peso-galo', rank: 4
  },
  figueiredo: {
    id: 'f-figueiredo', slug: 'deiveson-figueiredo', name: 'Deiveson Figueiredo', nickname: 'Deus da Guerra', countryCode: 'BR',
    countryName: 'Brasil', weightClass: 'Peso-galo', rank: 7
  },
  prates: {
    id: 'f-prates', slug: 'carlos-prates', name: 'Carlos Prates', nickname: 'The Nightmare', countryCode: 'BR',
    countryName: 'Brasil', weightClass: 'Peso meio-médio', rank: 8
  },
  buckley: {
    id: 'f-buckley', slug: 'joaquin-buckley', name: 'Joaquin Buckley', nickname: 'New Mansa', countryCode: 'US',
    countryName: 'Estados Unidos', weightClass: 'Peso meio-médio', rank: 9
  },
  lemos: {
    id: 'f-lemos', slug: 'amanda-lemos', name: 'Amanda Lemos', nickname: null, countryCode: 'BR',
    countryName: 'Brasil', weightClass: 'Peso-palha feminino', rank: 5
  },
  hill: {
    id: 'f-hill', slug: 'angela-hill', name: 'Angela Hill', nickname: 'Overkill', countryCode: 'US',
    countryName: 'Estados Unidos', weightClass: 'Peso-palha feminino', rank: 12
  },
  borralho: {
    id: 'f-borralho', slug: 'caio-borralho', name: 'Caio Borralho', nickname: 'The Natural', countryCode: 'BR',
    countryName: 'Brasil', weightClass: 'Peso-médio', rank: 7
  },
  allen: {
    id: 'f-allen', slug: 'brendan-allen', name: 'Brendan Allen', nickname: 'All In', countryCode: 'US',
    countryName: 'Estados Unidos', weightClass: 'Peso-médio', rank: 8
  },
  silva: {
    id: 'f-silva', slug: 'karine-silva', name: 'Karine Silva', nickname: 'Killer', countryCode: 'BR',
    countryName: 'Brasil', weightClass: 'Peso-mosca feminino', rank: 10
  },
  oconnell: {
    id: 'f-oconnell', slug: 'erin-oconnell', name: "Erin O'Connell", nickname: null, countryCode: 'IE',
    countryName: 'Irlanda', weightClass: 'Peso-mosca feminino', rank: null
  }
} as const

const startAt = nextSaturday.toISOString()
const earlyStart = new Date(nextSaturday.getTime() - 3 * 60 * 60_000).toISOString()

export const demoEvent: EventDTO = {
  id: 'event-demo',
  slug: 'ufc-fight-night-gamrot-salkilld',
  name: 'UFC Fight Night',
  headline: 'Gamrot x Salkilld',
  venue: 'Etihad Arena',
  city: 'Abu Dhabi',
  countryCode: 'AE',
  startAt,
  lockAt: earlyStart,
  status: 'published',
  sourceUrl: 'https://www.ufc.com.br/events',
  fights: [
    { id: 'fight-1', eventId: 'event-demo', segment: 'main_card', position: 1, scheduledRounds: 5, weightClass: 'Peso-leve', isTitleFight: false, red: fighters.gamrot, blue: fighters.salkilld, status: 'scheduled' },
    { id: 'fight-2', eventId: 'event-demo', segment: 'main_card', position: 2, scheduledRounds: 3, weightClass: 'Peso-galo', isTitleFight: false, red: fighters.sandhagen, blue: fighters.figueiredo, status: 'scheduled' },
    { id: 'fight-3', eventId: 'event-demo', segment: 'main_card', position: 3, scheduledRounds: 3, weightClass: 'Peso meio-médio', isTitleFight: false, red: fighters.prates, blue: fighters.buckley, status: 'scheduled' },
    { id: 'fight-4', eventId: 'event-demo', segment: 'prelims', position: 1, scheduledRounds: 3, weightClass: 'Peso-palha feminino', isTitleFight: false, red: fighters.lemos, blue: fighters.hill, status: 'scheduled' },
    { id: 'fight-5', eventId: 'event-demo', segment: 'prelims', position: 2, scheduledRounds: 3, weightClass: 'Peso-médio', isTitleFight: false, red: fighters.borralho, blue: fighters.allen, status: 'scheduled' },
    { id: 'fight-6', eventId: 'event-demo', segment: 'early_prelims', position: 1, scheduledRounds: 3, weightClass: 'Peso-mosca feminino', isTitleFight: false, red: fighters.silva, blue: fighters.oconnell, status: 'scheduled' }
  ]
}

export const demoPredictions: PredictionDTO[] = [
  { id: 'prediction-1', userId: 'demo-admin', fightId: 'fight-2', winnerId: 'f-sandhagen', method: 'decision', round: 3, createdAt: new Date().toISOString(), updatedAt: new Date().toISOString() },
  { id: 'prediction-2', userId: 'demo-admin', fightId: 'fight-4', winnerId: 'f-lemos', method: 'ko_tko', round: 2, createdAt: new Date().toISOString(), updatedAt: new Date().toISOString() }
]

export const demoLeaderboard: LeaderboardEntry[] = [
  { position: 1, userId: 'u1', username: 'nocaute', displayName: 'Marina KO', countryCode: 'BR', points: 187, perfectPicks: 23, winnersCorrect: 92, scoredFights: 128, trend: 2 },
  { position: 2, userId: 'u2', username: 'grapplingnerd', displayName: 'Leo Martins', countryCode: 'BR', points: 181, perfectPicks: 21, winnersCorrect: 95, scoredFights: 135, trend: -1 },
  { position: 3, userId: 'u3', username: 'southpaw', displayName: 'Nina Alves', countryCode: 'PT', points: 176, perfectPicks: 20, winnersCorrect: 88, scoredFights: 127, trend: 1 },
  { position: 4, userId: 'demo-admin', username: 'uhhvaimorrer', displayName: 'Gustavo Braga', countryCode: 'BR', points: 169, perfectPicks: 19, winnersCorrect: 86, scoredFights: 123, trend: 3 },
  { position: 5, userId: 'u5', username: 'cagewise', displayName: 'Rafa Lima', countryCode: 'BR', points: 162, perfectPicks: 18, winnersCorrect: 83, scoredFights: 122, trend: -2 }
]

export const demoProfile: PublicProfileDTO = {
  id: 'demo-admin',
  username: 'uhhvaimorrer',
  displayName: 'Gustavo Braga',
  bio: 'Organizador da LIGA UVM. Palpites de MMA, resenha e rivalidade saudável.',
  countryCode: 'BR',
  countryName: 'Brasil',
  avatarUrl: null,
  coverTheme: 'coral',
  socialLinks: [
    { platform: 'instagram', url: 'https://instagram.com/uhhvaimorrer' },
    { platform: 'youtube', url: 'https://youtube.com/@uhhvaimorrer' }
  ],
  stats: {
    points: 169, scoredFights: 123, winnerAccuracy: 69.9, methodAccuracy: 48.8, roundAccuracy: 42.3,
    perfectPicks: 19, currentStreak: 4, bestStreak: 9, averagePerEvent: 8.4, bestEventPoints: 16, globalPosition: 4
  },
  badges: [
    { slug: 'na-mosca', name: 'Na mosca', description: 'Conseguiu cinco palpites perfeitos.', icon: 'sparkles', earnedAt: '2026-06-18T12:00:00Z' },
    { slug: 'podio', name: 'Pódio', description: 'Terminou um evento no top 3.', icon: 'trophy', earnedAt: '2026-05-11T12:00:00Z' },
    { slug: 'casca-grossa', name: 'Casca-grossa', description: 'Pontuou cem lutas.', icon: 'award', earnedAt: '2026-04-20T12:00:00Z' },
    { slug: 'em-chamas', name: 'Em chamas', description: 'Pontuou em cinco eventos seguidos.', icon: 'flame', earnedAt: '2026-03-10T12:00:00Z' }
  ],
  recentEvents: [
    { eventId: 'past-1', eventName: 'UFC 330', headline: 'Makhachev x Machado Garry', startAt: '2026-06-28T23:00:00Z', points: 12, perfectPicks: 3, scoredFights: 14 },
    { eventId: 'past-2', eventName: 'UFC Fight Night', headline: 'Hernandez x Rodrigues', startAt: '2026-06-21T23:00:00Z', points: 9, perfectPicks: 1, scoredFights: 13 },
    { eventId: 'past-3', eventName: 'UFC 329', headline: 'Topuria x Evloev', startAt: '2026-06-14T23:00:00Z', points: 15, perfectPicks: 4, scoredFights: 14 }
  ],
  createdAt: '2026-01-12T12:00:00.000Z',
  isSuspended: false
}

export const demoLeagues: LeagueDTO[] = [
  { id: 'league-1', name: 'Resenha do Sábado', description: 'A liga dos amigos que nunca concordam no main event.', ownerId: 'demo-admin', inviteCode: 'UVM-SABADO', membersCount: 12, startsAt: '2026-02-01T00:00:00.000Z', userPosition: 2, userPoints: 118 },
  { id: 'league-2', name: 'Só Casca-Grossa', description: 'Valendo apenas a glória e o print no grupo.', ownerId: 'u1', inviteCode: 'CASCA-26', membersCount: 38, startsAt: '2026-03-01T00:00:00.000Z', userPosition: 7, userPoints: 94 }
]

export const demoChallenges: ChallengeDTO[] = [
  {
    id: 'challenge-1', eventId: demoEvent.id, eventName: `${demoEvent.name}: ${demoEvent.headline}`,
    challenger: { id: 'u2', username: 'grapplingnerd', displayName: 'Leo Martins', avatarUrl: null },
    opponent: { id: 'demo-admin', username: 'uhhvaimorrer', displayName: 'Gustavo Braga', avatarUrl: null },
    status: 'accepted', inviteCode: 'DUELO-UVM-82'
  }
]
